// @flow
import React from 'react'
import withPage from 'server/withPage'
import gql from 'graphql-tag'
import { graphql } from 'react-apollo'
import SignUpSentPage from 'components/pages/SignUpSentPage'
import { bindActionCreators } from 'redux'
import { setUIState, containerIds } from 'redux/modules/ui'
import { viewerFragment } from 'api/fragments'
import { authUrlWithQuery } from 'helpers/format'
import { checkTokenExpired } from 'helpers/auth'
import { amplitudeLogEvent } from 'helpers/amplitude'

type PropTypes = {
  data: {
    viewer: {
      owners: {
        results: Array<Owner>,
      },
    },
  },
  ui: {},
  actions: {
    setUIState: Function,
  },
  config: {},
}

class Container extends React.Component<PropTypes> {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    amplitudeLogEvent('Sent Confirmation')
  }

  render() {
    return <SignUpSentPage {...this.props} />
  }
}

const pageQuery = gql`
query SignUpPage {
  viewer {
    ${viewerFragment}
  }
}`
const withData = graphql(pageQuery, {
  skip: checkTokenExpired(),
  options: props => {
    const variables = {}
    return { variables }
  },
})

function mapStateToProps(state) {
  return state
}
function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = { setUIState }
  return { actions: bindActionCreators(bindActions, dispatch) }
}
export default withPage(Container, mapStateToProps, mapDispatchToProps, {
  graphql: withData,
})
